<template>
    <v-dialog v-model="mostrar" persistent max-width="900" scrollable>
		<v-card max-height="600px" max-width="900" class="mx-auto">
			<v-card-title class="primary white--text">{{evento.titulo}}</v-card-title>
            <v-card-text class="pt-4">
            <h3 class="display-lg-3" slot="header"></h3>
			<div slot="body">
				<div>
					<div>
						<p class="display-lg-1">Data: {{evento.data_evento}}<br />
						
						Horário: {{evento.inicio}}<br />
						Local: {{evento.descricao_local}}<br />
						Tipo: {{evento.descricao_tipo}}<br />
						Grau: {{evento.grau}} <br />
						Observação: {{evento.observacao}} <br />
						Sua participação: {{evento.confirmacao}} </p>
					</div>
				</div>
			</div>
            </v-card-text>
            <v-card-actions>
				<v-btn color="primary" text @click="confirmarEvento(evento)">Participar</v-btn>
				<v-btn color="primary" text @click="recusarEvento(evento)">Não Participar</v-btn>
                <v-spacer></v-spacer>
				<v-btn color="primary" text @click="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
    import {baseApiUrl, showError, showSuccess} from '@/config/global'
    import axios from 'axios'
    import { mapState } from 'vuex'
    
export default{
    props:['mostrar', 'evento'],
    data(){
        return{
        }
    },
    computed:{
			... mapState(['user']),
		},
    methods:{
        fechar(){
            this.$emit('fecharDetalhes')
        },

        confirmarEvento(ev){
                const url = `${baseApiUrl}/eventos/confirmar.php`
                const params = {
                    id_evento: ev.id,
                    id_iniciado: this.user.iniciado,
                    statusConfirmacao: "1"
                }
                
                axios.post(url, params).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
						
						this.$emit('eventoConfirmado', ev.id)

                    }else{
                        showError(res.data.mensagem)
                    }
                    
                })
            },

			 recusarEvento(ev){
                const url = `${baseApiUrl}/eventos/confirmar.php`
                const params = {
                    id_evento: ev.id,
                    id_iniciado: this.user.iniciado,
                    statusConfirmacao: "2"
                }
                
                axios.post(url, params).then(res => {
                    if(res.data.codigo == '01'){
                        showSuccess(res.data.mensagem)
                        this.$emit('eventoRecusado', ev.id)
                    }else{
                        showError(res.data.mensagem)
                    }
                    
                })
            },
    },
}
</script>

<style scoped>

</style>